import gql from 'graphql-tag';

export const ReactedUsersQuery = gql`
	query ReactedUsersQuery(
		$contentId: String!
		$containerId: String!
		$containerType: ContainerType!
		$contentType: GraphQLReactionContentType!
		$emojiId: String!
	) {
		reactedUsers(
			contentId: $contentId
			containerId: $containerId
			containerType: $containerType
			contentType: $contentType
			emojiId: $emojiId
		) {
			count
			emojiId
			reacted
			users {
				accountId
				displayName
				profilePicture {
					path
				}
			}
		}
	}
`;
